// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"4b297815","34":"4b297815","279":"6ca4062c","525":"2c4336e0","636":"4b297815"}[chunkId] + ".chunk.css";
};